<mat-date-range-input (click)="picker.open()" [formGroup]="range" [rangePicker]="picker">
  <input readonly (dateChange)="startChange($event)" matStartDate formControlName="start" placeholder="" />
  <input readonly (dateChange)="endChange($event)" matEndDate formControlName="end" placeholder="" />
</mat-date-range-input>

<mat-date-range-picker [touchUi]="isMobile" startView="month" #picker>
  <ng-container *ngIf="isMobile">
    <mat-date-range-picker-actions>
      <button mat-button matDateRangePickerCancel>Cancel</button>
      <button mat-raised-button color="primary" matDateRangePickerApply>Apply</button>
    </mat-date-range-picker-actions>
  </ng-container>
</mat-date-range-picker>
